import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

function MobileProjectMenu({ nextImage, prevImage, nextProject, prevProject, setCurrentIndex}) {
  const location = useLocation();
  const navigate = useNavigate();
  const isProjectPage = location.pathname.startsWith("/recent/");

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (isProjectPage) {
        if (event.key === "ArrowLeft") prevImage();
        else if (event.key === "ArrowRight") nextImage();
        else if (event.key === "Escape") navigate("/recent");
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isProjectPage, prevImage, nextImage, navigate]);

  
  
  return (
    <div className="mobile-scroll-wrapper">
      <div className="MobileProject ">
        <button
          onClick={() => {
            setCurrentIndex(0);
            navigate(`/recent/${prevProject.route}`);
          }}
          className="mobile-buttons"
        >
          &#171;
        </button>
        <button onClick={prevImage} className="mobile-buttons">
          &#8249;
        </button>
        <button
          className="mobile-buttons"
          id="exit"
          onClick={() => navigate(`/recent`)}
        >
          exit
        </button>
        <button onClick={nextImage} className="mobile-buttons">
          &#8250;
        </button>
        <button
          onClick={() => {
            setCurrentIndex(0);
            navigate(`/recent/${nextProject.route}`);
          }}
          className="mobile-buttons"
        >
          &#187;
        </button>
      </div>
    </div>
  );
}

export default MobileProjectMenu;
